import { observer } from 'mobx-react'
import { FC } from 'react'
import Link from 'next/link'
import { IJobBase } from '../../../types'
import styles from './index.module.scss'
import { JobItemContent } from '../JobItemContent'
import { JobCardButtonGroup } from '../JobCardButtonGroup'

type Props = {
  job: IJobBase
}

export const JobItem: FC<Props> = observer(({ job }) => {
  const linkToJobDetails = `/jobs/${job?.slug}`

  return (
    <div className={styles.container}>
      <Link href={linkToJobDetails}>
        <a>
          <JobItemContent job={job} />
        </a>
      </Link>
      <JobCardButtonGroup job={job} />
    </div>
  )
})
